
import { useEffect, useState } from "react";
import React from "react";
import './App.css';
// material-ui
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Button, 
  Card, 
  CardContent,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import bbfTheme from './theme/bbfTheme';

const Home = () => {
  const [hostedUI, setHostedUI] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const initHome = async () => {
    console.log('initializing......')
    let hostedUi = process.env.REACT_APP_HOSTED_UI;
    console.log(hostedUi);
    setHostedUI(hostedUi);
  }

  useEffect(() => {
    initHome();
  }, []);

  return (
    <ThemeProvider theme={bbfTheme}>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #283593 0%, #00bcd4 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Background decorative elements */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.1,
            background: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat`,
          }}
        />
        
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Grid container sx={{ minHeight: '100vh' }} alignItems="center">
            {/* Left side - Login Form */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: isMobile ? 'center' : 'flex-start',
                  textAlign: isMobile ? 'center' : 'left',
                  px: { xs: 2, md: 4 },
                  py: 4,
                }}
              >
                {/* Logo */}
                <Box
                  component="img"
                  src="/vtkids-logo-gray.png"
                  alt="Vermont Kids Data Logo"
                  sx={{
                    height: { xs: 80, md: 100 },
                    mb: 3,
                    filter: 'brightness(0) invert(1)',
                  }}
                />
                
                {/* Main heading */}
                <Typography
                  variant="h2"
                  sx={{
                    color: 'white',
                    fontWeight: 700,
                    fontSize: { xs: '2rem', md: '2.5rem' },
                    mb: 2,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  }}
                >
                  Vermont Kids Data
                </Typography>
                
                <Typography
                  variant="h5"
                  sx={{
                    color: 'rgba(255,255,255,0.9)',
                    fontWeight: 400,
                    mb: 4,
                    fontSize: { xs: '1.1rem', md: '1.25rem' },
                  }}
                >
                  AI-Powered Early Childhood Analytics
                </Typography>

                {/* Login Card */}
                <Card
                  sx={{
                    width: '100%',
                    maxWidth: 400,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                    borderRadius: 3,
                    backdropFilter: 'blur(10px)',
                    background: 'rgba(255,255,255,0.95)',
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Typography
                      variant="h4"
                      component="h1"
                      sx={{
                        mb: 2,
                        textAlign: 'center',
                        color: bbfTheme.palette.primary.main,
                        fontWeight: 600,
                      }}
                    >
                      Administration Portal
                    </Typography>
                    
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 3,
                        textAlign: 'center',
                        color: 'text.secondary',
                        lineHeight: 1.6,
                      }}
                    >
                      Access the comprehensive data management system for Vermont's early childhood programs
                    </Typography>
                    
                    <Button
                      href={hostedUI}
                      variant="contained"
                      fullWidth
                      size="large"
                      sx={{
                        py: 1.5,
                        fontSize: '1.1rem',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: 2,
                        background: `linear-gradient(45deg, ${bbfTheme.palette.primary.main}, ${bbfTheme.palette.secondary.main})`,
                        '&:hover': {
                          background: `linear-gradient(45deg, ${bbfTheme.palette.primary.dark || '#1e2a5c'}, ${bbfTheme.palette.secondary.dark || '#0097a7'})`,
                          transform: 'translateY(-1px)',
                          boxShadow: '0 6px 20px rgba(40,53,147,0.4)',
                        },
                        transition: 'all 0.3s ease',
                      }}
                    >
                      Secure Login
                    </Button>
                  </CardContent>
                </Card>
              </Box>
            </Grid>

            {/* Right side - Description */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  px: { xs: 2, md: 4 },
                  py: 4,
                  textAlign: isMobile ? 'center' : 'left',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    color: 'white',
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { xs: '1.75rem', md: '2.125rem' },
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  }}
                >
                  Empowering Vermont's Future
                </Typography>
                
                <Typography
                  variant="h6"
                  sx={{
                    color: 'rgba(255,255,255,0.9)',
                    mb: 4,
                    fontWeight: 400,
                    lineHeight: 1.6,
                  }}
                >
                  Our AI-driven platform provides comprehensive insights into early childhood development, 
                  education outcomes, and policy impact across Vermont.
                </Typography>

                <Box sx={{ mb: 4 }}>
                  {[
                    'Advanced analytics for child care professionals',
                    'Data-driven insights for educators and researchers', 
                    'Policy intelligence for lawmakers and administrators',
                    'Real-time monitoring of early childhood programs'
                  ].map((feature, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 2,
                        justifyContent: isMobile ? 'center' : 'flex-start',
                      }}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: bbfTheme.palette.secondary.main,
                          mr: 2,
                          flexShrink: 0,
                        }}
                      />
                      <Typography
                        variant="body1"
                        sx={{
                          color: 'rgba(255,255,255,0.8)',
                          fontSize: '1rem',
                        }}
                      >
                        {feature}
                      </Typography>
                    </Box>
                  ))}
                </Box>

                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255,255,255,0.7)',
                    fontStyle: 'italic',
                  }}
                >
                  "Using cutting-edge AI to better understand and support the state of children 
                  and early childhood development in Vermont."
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default Home;

/*
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }} >
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={9}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 240,
              }}
            >
              <Chart />
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={4} lg={3}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 240,
              }}
            >
              <Deposits />
            </Paper>
          </Grid>
          
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Reports />
            </Paper>
          </Grid>
        </Grid>
        <Copyright sx={{ pt: 4 }} />
      </Container>
      */